import deviceStatistics from "@/views/deviceStatistics/deviceStatistics";
export default deviceStatistics;
